import { FC } from 'react';

import SVGIcon from 'react-inlinesvg';

import ConnectorsDark from '@assets/svg/connectors-dark.svg';
import ConnectorsLight from '@assets/svg/connectors-light.svg';
import ConnectorsSmall from '@assets/svg/connectors-small.svg';

import styles from './index.module.scss';

type Props = {
	type?: 'light' | 'dark' | 'small';
};

const getSource = (type: Props['type']): string => {
	switch (type) {
		case 'light':
			return ConnectorsLight;
		case 'dark':
			return ConnectorsDark;
		default:
			return ConnectorsSmall;
	}
};

const getWidth = (type: Props['type']): number => {
	switch (type) {
		case 'light':
			return 1542;
		case 'dark':
			return 1440;
		default:
			return 1462;
	}
};

const getHeight = (type: Props['type']): number => {
	switch (type) {
		case 'light':
			return 321;
		case 'dark':
			return 218;
		default:
			return 133;
	}
};

const Background: FC<Readonly<Props>> = ({ type = 'light' }) => (
	<SVGIcon src={getSource(type)} width={getWidth(type)} height={getHeight(type)} className={styles.background} />
);

export default Background;
